//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { AddIcon, ArrowBackIcon, DeleteIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Icon,
  Flex,
  Input,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Field, FieldArray, Form, Formik } from "formik";
import { observer } from "mobx-react-lite";
import React from "react";
import { array, object } from "yup";
import { SingleFormButton } from "./FormButtons";

const CertificationsForm: React.FC<{
  loading: boolean;
  onBackClick: () => void;
  subject: string;
  initialValues: {
    certifications: Array<{ name: string; institution: string }>;
  };
  onSubmit: (values: any) => Promise<any>;
}> = observer(({ loading, onBackClick, subject, initialValues, onSubmit }) => {
  const validationSchema = object().shape({
    certifications: array().required("Add your certifications"),
  });

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values) => onSubmit(values)}
      validationSchema={validationSchema}
    >
      {({ handleSubmit, values }) => {
        return (
          <Box className="certifications-and-awards">
            <Button
              mb={6}
              onClick={onBackClick}
              leftIcon={<ArrowBackIcon />}
              variant="link"
              colorScheme="blue"
            >
              Back
            </Button>

            <Stack pb={6}>
              <Text
                fontSize="3xl"
                lineHeight="shorter"
                fontWeight="bold"
                as="h1"
              >
                Add awards or certifications
              </Text>
              <Text mt={1} color="gray.700">
                If you have any special awards, recognition or certifications
                that are relevant, and that further endorse your expertise in{" "}
                {subject}, please add them here. This is optional.
              </Text>
            </Stack>

            <Form>
              <Box mb={8} pb={20}>
                <FieldArray name="certifications">
                  {({ push, remove, form }) => {
                    const certifications = form.values.certifications;
                    return (
                      <Box>
                        <Button
                          mb={8}
                          colorScheme="blue"
                          variant="outline"
                          leftIcon={<AddIcon />}
                          onClick={() => push({ name: "", institution: "" })}
                        >
                          Add certification
                        </Button>
                        {certifications.map((cert, index) => (
                          <Stack
                            mb={4}
                            p={[5, 6]}
                            spacing={4}
                            borderWidth="2xs"
                            borderColor="neutral.500"
                            rounded="lg"
                            key={`${index}_${certifications.length}`}
                          >
                            <Stack
                              direction={{ base: "column", md: "row" }}
                              spacing={[4, 6]}
                            >
                              <Field name={`certifications.${index}.name`}>
                                {(fieldInstance) => (
                                  <FormControl>
                                    <FormLabel>
                                      <Flex
                                        justifyContent="space-between"
                                        align="center"
                                      >
                                        <Text>Name of award</Text>
                                        <Button
                                          onClick={() => remove(index)}
                                          aria-label="Delete certificate"
                                          colorScheme="red"
                                          variant="link"
                                        >
                                          Delete item
                                        </Button>
                                      </Flex>
                                    </FormLabel>
                                    <Input
                                      defaultValue={
                                        form.values.certifications[index]?.name
                                      }
                                      borderColor="neutral.500"
                                      {...fieldInstance.field}
                                      placeholder="Enter title of award"
                                    />
                                  </FormControl>
                                )}
                              </Field>
                              <Field
                                name={`certifications.${index}.institution`}
                              >
                                {(fieldInstance) => (
                                  <FormControl>
                                    <FormLabel>
                                      From which organization?
                                    </FormLabel>
                                    <Input
                                      borderColor="neutral.500"
                                      {...fieldInstance.field}
                                      placeholder="Enter name of organization"
                                    />
                                  </FormControl>
                                )}
                              </Field>
                            </Stack>
                          </Stack>
                        ))}
                      </Box>
                    );
                  }}
                </FieldArray>
              </Box>

              <SingleFormButton
                nextText="Save certifications"
                isLoading={loading}
                onNextClick={handleSubmit}
              />
            </Form>
          </Box>
        );
      }}
    </Formik>
  );
});

export default CertificationsForm;
